import { connect } from "react-redux";

import { hideLoadingValue, showLoadingValue } from "../actions";
import History from '../pages/app/history';

const mapStateToProps = (state, ownProps) => {
    return {
        loading: state.isLoadingReducer.loading
    }
}

const mapDispatchToProps = {
    hideLoadingValue,
    showLoadingValue
};

export default connect(mapStateToProps, mapDispatchToProps)(History);